/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.fill.js";
export default {
  name: 'Skeleton',
  props: {
    row: {
      type: [Number, String],
      default: 3
    },
    title: {
      type: Boolean,
      default: false
    },
    avatar: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    animate: {
      type: Boolean,
      default: false
    },
    avatarSize: {
      type: String
    },
    avatarShape: {
      type: String,
      default: 'round'
    },
    titleWidth: [Number, String],
    rowWidth: [Number, String]
  },
  data: function data() {
    return {};
  },
  render: function render(h) {
    if (!this.loading) {
      return h('div', this.$slots.default);
    }

    var Avatar = this.avatar ? h('div', {
      class: ['avatar']
    }) : null;
    var Title = this.title ? h('div', {
      class: ['skeleton_row'],
      style: {
        width: '40%'
      }
    }) : null;
    var Rows = h('div', {
      class: 'row'
    }, Array(this.row).fill('').map(function (_, i) {
      return h('div', {
        class: ['row-item', 'skeleton_row'],
        style: {
          width: i & 1 ? '60%' : '100%'
        }
      });
    }));
    var Content = h('div', {
      class: ['content']
    }, [Title, Rows]);
    return h('div', {
      class: {
        skeleton: true,
        'skeleton--animate': this.animate
      }
    }, [Avatar, Content]);
  }
};